import React from 'react';

import { Textarea } from './wrapper';

type InputTextareaProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> & {
  hasError?: boolean;
  children?: string;
};

const InputTextarea = ({ hasError, children, ...props }: Omit<InputTextareaProps, 'ref'>) => (
  <Textarea $hasError={hasError} {...props}>
    {children}
  </Textarea>
);

export default InputTextarea;
